class PredictiveSearch {
  constructor() {
    this.searchInput = document.querySelector('.search-input');
    this.searchResults = document.getElementById('search-results');
    this.searchResultsList = document.getElementById('search-results-list');
    this.searchForm = document.querySelector('.search-form');
    this.searchContainer = document.querySelector('.search-container');
    
    if (this.searchInput && this.searchResults && this.searchResultsList) {
      this.init();
    }
  }
  
  init() {
    let searchTimeout;
    
    this.searchInput.addEventListener('input', (e) => {
      const query = e.target.value.trim();
      
      clearTimeout(searchTimeout);
      
      if (query.length < 2) {
        this.hideResults();
        return;
      }
      
      searchTimeout = setTimeout(() => {
        this.performSearch(query);
      }, 300);
    });
    
    document.addEventListener('click', (e) => {
      if (this.searchContainer && !this.searchContainer.contains(e.target)) {
        this.hideResults();
      }
    });
    
    if (this.searchForm) {
      this.searchForm.addEventListener('submit', (e) => {
        if (this.searchResults.style.display !== 'none' && this.searchResults.style.display !== '') {
          // Let it submit to search page
        }
      });
    }
    
    this.searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.hideResults();
      }
    });
  }
  
  async performSearch(query) {
    try {
      const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const searchUrl = `${rootUrl}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`;
      
      const response = await fetch(searchUrl);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      const products = data.resources?.results?.products || [];
      
      if (products.length > 0) {
        this.displayResults(products, query);
      } else {
        this.displayNoResults();
      }
    } catch (error) {
      console.error('Search error:', error);
      this.displayNoResults();
    }
  }
  
  displayResults(products, query) {
    // Clear completely
    this.searchResultsList.innerHTML = '';
    
    // Create header
    const header = document.createElement('div');
    header.className = 'search-results-header';
    header.innerHTML = '<h3>Vorschläge</h3>';
    this.searchResultsList.appendChild(header);
    
    // Add products
    products.forEach(product => {
      const resultItem = document.createElement('a');
      resultItem.href = product.url;
      resultItem.className = 'search-result-item';
      
      // Image
      const imageHtml = product.featured_image ? 
        `<img src="${product.featured_image.url}" alt="${product.featured_image.alt}" class="search-result-image">` :
        `<div class="search-result-image" style="background: var(--color-background-secondary); display: flex; align-items: center; justify-content: center; color: var(--color-text-muted); opacity: 0.5;">
           <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>
         </div>`;
      
      // Category
      let category = '';
      if (product.product_type && product.product_type !== '') {
        category = product.product_type;
      } else if (product.vendor && product.vendor !== '') {
        category = product.vendor;
      }
      const categoryHtml = category ? `<div class="search-result-category">${this.escapeHtml(category)}</div>` : '';
      
      // Title with highlighting
      const titleHtml = `<div class="search-result-title">${this.highlightMatch(product.title, query)}</div>`;
      
      // Price
      const priceHtml = `<div class="search-result-price">${product.price}</div>`;
      
      // Info container
      const infoHtml = `
        <div class="search-result-info">
          ${categoryHtml}
          ${titleHtml}
          ${priceHtml}
        </div>
      `;
      
      // Complete item
      resultItem.innerHTML = imageHtml + infoHtml;
      this.searchResultsList.appendChild(resultItem);
    });
    
    // Create footer
    const footer = document.createElement('div');
    footer.className = 'search-results-footer';
    footer.innerHTML = `<a href="${window.Shopify.routes.root}search?q=${encodeURIComponent(query)}" class="view-all-results">Alle Ergebnisse anzeigen</a>`;
    this.searchResultsList.appendChild(footer);
    
    this.showResults();
  }
  
  displayNoResults() {
    this.searchResultsList.innerHTML = `
      <div class="search-results-header">
        <h3>Vorschläge</h3>
      </div>
      <div class="search-result-item" style="justify-content: center; color: var(--color-text-muted);">
        Keine Produkte gefunden
      </div>
      <div class="search-results-footer">
        <a href="${window.Shopify.routes.root}search?q=${encodeURIComponent(this.searchInput.value)}" class="view-all-results">Alle Ergebnisse anzeigen</a>
      </div>
    `;
    this.showResults();
  }
  
  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
  
  highlightMatch(text, query) {
    if (!query) return text;
    const regex = new RegExp(`(${query})`, 'gi');
    return text.replace(regex, '<strong style="color: var(--color-accent);">$1</strong>');
  }
  
  showResults() {
    this.searchResults.style.display = 'block';
    this.searchResults.classList.add('animate-fade-in');
  }
  
  hideResults() {
    this.searchResults.style.display = 'none';
    this.searchResults.classList.remove('animate-fade-in');
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new PredictiveSearch();
});
